// @flow

import React, { Component, PropTypes } from 'react';
import ExternalLink from 'ExternalLink/ExternalLink';
import styles from './DefaultLmis.less';

const LMIS_CAMPAIGN_CODE = 'lrn:skj:sklm:jbs:btm:banner';

const HDR_QUERY = { CampaignCode: `${LMIS_CAMPAIGN_CODE}:hdr` };
const LNK_QUERY = { CampaignCode: `${LMIS_CAMPAIGN_CODE}:lnk` };
const BTN_QUERY = { CampaignCode: `${LMIS_CAMPAIGN_CODE}:btn` };
const LG_QUERY = { CampaignCode: `${LMIS_CAMPAIGN_CODE}:lg` };

const LOCALISED_LINKS = {
  AU: {
    home: 'http://www.seeklearning.com.au/',
    tafeCourses: 'http://www.seeklearning.com.au/tafe-courses',
    onlineCourses: 'http://www.seeklearning.com.au/online-courses',
    coursesByOccupation: 'http://www.seeklearning.com.au/courses-by-occupation'
  },
  NZ: {
    home: 'http://www.seeklearning.co.nz/',
    tafeCourses: 'http://www.seeklearning.co.nz/tafe-courses',
    onlineCourses: 'http://www.seeklearning.co.nz/online-courses',
    coursesByOccupation: 'http://www.seeklearning.co.nz/courses-by-occupation'
  }
};

export default class DefaultLmis extends Component {

  static propTypes = {
    locale: PropTypes.string.isRequired
  };

  shouldComponentUpdate(nextProps:any) {
    return this.props.locale !== nextProps.locale;
  }

  render() {
    const links = LOCALISED_LINKS[this.props.locale === 'NZ' ? 'NZ' : 'AU'];

    return (
      <div className={styles.root} data-automation="default-lmis">
        <h1>
          <ExternalLink className={styles.title} target="_blank" rel="noopener noreferrer" href={links.home} query={HDR_QUERY}>
            Courses that get you job-ready
          </ExternalLink>
        </h1>
        <ul className={styles.promoList}>
          <li className={styles.promoListItem}>Industry recognised providers</li>
          <li className={styles.promoListItem}>Experts in career related education</li>
        </ul>
        <ul className={styles.courseList}>
          <li className={styles.courseListItem}>
            <ExternalLink className={styles.courseListLink} target="_blank" rel="noopener noreferrer" href={links.tafeCourses} query={LNK_QUERY}>
              TAFE
            </ExternalLink>
          </li>
          <li className={styles.courseListItem}>
            <ExternalLink className={styles.courseListLink} target="_blank" rel="noopener noreferrer" href={links.onlineCourses} query={LNK_QUERY}>
              Online
            </ExternalLink>
          </li>
          <li className={styles.courseListItem}>
            <ExternalLink className={styles.courseListLink} target="_blank" rel="noopener noreferrer" href={links.coursesByOccupation} query={LNK_QUERY}>
              Courses by industry
            </ExternalLink>
          </li>
        </ul>
        <ExternalLink className={styles.button} target="_blank" rel="noopener noreferrer" href={links.home} query={BTN_QUERY}>
          Explore courses
        </ExternalLink>
        <ExternalLink className={styles.logo} target="_blank" rel="noopener noreferrer" href={links.home} query={LG_QUERY} />
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/Lmis/DefaultLmis/DefaultLmis.js
 **/